export const panelRoles = [
  { value: 'administrator', label: 'Администратор' },
  { value: 'cs_employee', label: 'Сотрудник КС' },
  { value: 'user', label: 'Пользователь' },
  { value: 'guest', label: 'Гость' },
];

export const serviceRoles = [
  { value: 'rks', label: 'Руководитель КС' },
  { value: 'division_head', label: 'Руководитель дивизиона' },
  { value: 'manager', label: 'Менеджер' },
  { value: 'consultant', label: 'Консультант' },
];

export const panelRoleLabel = Object.fromEntries(panelRoles.map((role) => [role.value, role.label]));

export const serviceRoleLabel = {
  rks: 'Руководитель КС',
  rd: 'Руководитель дивизиона',
  division_head: 'Руководитель дивизиона',
  manager: 'Менеджер',
  consultant: 'Консультант',
};

export const sectionIcons = {
  dashboard: 'home',
  client_base: 'people',
  invites: 'checklist',
  red_points: 'red-points',
  points: 'red-points',
  discounts: 'percent',
  promo: 'tag',
  promocodes: 'tag',
  users: 'hubot',
  managers: 'briefcase',
  journal: 'note',
  audit_log: 'note',
  settings: 'gear',
};

export const eventLabels = {
  panel_login: 'Вход в панель',
  panel_logout: 'Выход из панели',
  session_revoked: 'Завершена отдельная сессия',
  sessions_revoked_all: 'Завершены все сессии',
  user_created: 'Создан пользователь',
  invitation_sent: 'Отправлено приглашение',
  role_changed: 'Изменена роль',
  cs_role_changed: 'Изменена роль в клиентской службе',
  environment_switcher_visibility_changed: 'Изменена видимость переключателя окружения',
  user_profile_changed: 'Изменены данные пользователя',
  email_change_requested: 'Изменена электронная почта',
  password_reset_by_admin: 'Пароль сброшен администратором',
  password_changed_by_user: 'Пароль изменён пользователем',
  user_deleted: 'Удалён пользователь',
  user_restored: 'Восстановлен пользователь',
  manager_dismissed: 'Сотрудник уволен',
};

export function fullName(user) {
  return `${user.firstName} ${user.lastName}`;
}

export function initials(firstName, lastName) {
  return `${firstName || ''} ${lastName || ''}`
    .split(' ')
    .filter(Boolean)
    .map((part) => part[0])
    .join('')
    .toUpperCase();
}

export const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const emailErrorText = 'Введите корректную электронную почту';
export const phoneErrorText = 'Введите корректный телефон';

export function isCompletePhone(value) {
  const digits = String(value || '').replace(/\D/g, '');
  let rest = digits;
  if (rest.startsWith('7') || rest.startsWith('8')) rest = rest.slice(1);
  return rest.length === 10;
}

export function localizeErrorText(text) {
  if (!text) return '';
  if (/this value is not a valid email address/i.test(text)) return emailErrorText;
  return text;
}

export function formatPhone(value) {
  const digits = String(value || '').replace(/\D/g, '');
  let rest = digits;
  if (rest.startsWith('7') || rest.startsWith('8')) rest = rest.slice(1);
  rest = rest.slice(0, 10);
  if (!rest) return '';
  const parts = [rest.slice(0, 3), rest.slice(3, 6), rest.slice(6, 8), rest.slice(8, 10)];
  let text = '+7';
  if (parts[0]) text += ` ${parts[0]}`;
  if (parts[1]) text += ` ${parts[1]}`;
  if (parts[2]) text += `-${parts[2]}`;
  if (parts[3]) text += `-${parts[3]}`;
  return text;
}

export function formatDateTime(value) {
  if (!value) return { date: '', time: '', text: '—' };
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return { date: '', time: '', text: '—' };
  const pad = (number) => String(number).padStart(2, '0');
  const day = `${pad(date.getDate())}.${pad(date.getMonth() + 1)}.${date.getFullYear()}`;
  const time = `${pad(date.getHours())}:${pad(date.getMinutes())}`;
  return { date: day, time, text: `${day}, ${time}` };
}

export const passwordRules = [
  { id: 'length', label: 'Не короче 8 символов', test: (value) => value.length >= 8 },
  { id: 'latin', label: 'Только латиница', test: (value) => value.length > 0 && /^[\x20-\x7E]+$/.test(value) },
  { id: 'upper', label: 'Минимум одна заглавная буква', test: (value) => /[A-Z]/.test(value) },
  { id: 'digit', label: 'Минимум одна цифра', test: (value) => /\d/.test(value) },
  { id: 'symbol', label: 'Минимум один спецсимвол', test: (value) => /[^A-Za-z0-9]/.test(value) },
];
